import { useClientTranslations } from "../../../lib/i18n/client";
import styles from "./TrackSkeleton.module.css";

/**
 * TrackSkeleton (TRACK-03 backstop).
 *
 * Three-block whole-page loading skeleton — Current Step (tall), Calendar
 * (medium), Coming Up (tall) — matching the page section ordering on
 * `/track`. Used by `TrackPage` (Plan 36-07) while the events query is
 * pending. Animation matches the `GetReadyPage` shimmer cadence so the two
 * pages feel consistent.
 */
export function TrackSkeleton() {
	const { t } = useClientTranslations("track");
	return (
		<div
			className={styles.container}
			role="status"
			aria-busy="true"
			aria-label={t("loading.ariaLabel")}
		>
			<div className={`${styles.block} ${styles.tall}`} />
			<div className={`${styles.block} ${styles.medium}`} />
			<div className={`${styles.block} ${styles.tall}`} />
		</div>
	);
}
